{
  "version": 1,
  "asset_id": "3103e190-aab4-4a41-92a1-3b3b0a5dbe65",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/3103e190-aab4-4a41-92a1-3b3b0a5dbe65/hiatal-type-1-es-v3-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/3103e190-aab4-4a41-92a1-3b3b0a5dbe65/hiatal-type-1-es-v3-1200.jpg",
  "original_filename": "hiatal-type-1-es-v3-1200.jpg",
  "size": 206488,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:09:04Z"
}
